import script from "./TravelListView.vue?vue&type=script&lang=ts&setup=true"
export * from "./TravelListView.vue?vue&type=script&lang=ts&setup=true"

import "./TravelListView.vue?vue&type=style&index=0&id=54da95f5&lang=scss"

const __exports__ = script;

export default __exports__